import { render, staticRenderFns } from "./BannerCTA.vue?vue&type=template&id=3fc98c54&"
import script from "./BannerCTA.vue?vue&type=script&lang=js&"
export * from "./BannerCTA.vue?vue&type=script&lang=js&"
import style0 from "./BannerCTA.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports